import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css'; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/Usuario/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      // Manejo de Rate Limiting (Error 429) en el Login
      if (response.status === 429) {
        throw new Error('Demasiados intentos. Por favor espera 1 minuto.');
      }

      if (!response.ok) {
        throw new Error('Usuario o contraseña incorrectos');
      }

      // CAMBIO IMPORTANTE: Desestructuramos la respuesta
      const data = await response.json(); 
      const { token, user } = data;

      // Guardamos el token y el usuario por separado
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      navigate('/admin'); 

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Iniciar Sesión (Admin)</h2>
        <div className="form-group">
          <label htmlFor="username">Usuario</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="login-error">{error}</p>}
        <button type="submit" className="login-button">Ingresar</button>
      </form>
    </div>
  );
};

export default Login;